import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || t.admin.loginError);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-white/20 rounded-none focus:border-brand-light focus:outline-none text-white placeholder-zinc-600 py-3 transition-colors";

  return (
    <div className="bg-obsidian min-h-screen flex items-center justify-center px-6 grain" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-12">
          <Logo />
        </div>
        <h1 className="font-heading font-black uppercase tracking-tighter text-white text-3xl mb-8 text-center">
          {t.admin.login}
        </h1>
        <form onSubmit={onSubmit} className="space-y-6" data-testid="login-form">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder={t.admin.email} className={inputCls} data-testid="login-email" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder={t.admin.password} className={inputCls} data-testid="login-password" />
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-brand text-black font-bold uppercase tracking-wider py-4 hover:bg-brand-hover transition-colors flex items-center justify-center gap-2 disabled:opacity-50" data-testid="login-submit">
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> {t.admin.loggingIn}</> : t.admin.login}
          </button>
        </form>
      </div>
    </div>
  );
}
